import { render } from "./OidoCardSection.vue?vue&type=template&id=77e00e41&scoped=true"
import script from "./OidoCardSection.vue?vue&type=script&lang=js"
export * from "./OidoCardSection.vue?vue&type=script&lang=js"

import "./OidoCardSection.vue?vue&type=style&index=0&id=77e00e41&scoped=true&lang=css"
import "./OidoCardSection.vue?vue&type=style&index=1&id=77e00e41&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e00e41"]])

export default __exports__